import { render } from "./AddMarginModal.vue?vue&type=template&id=ba43d5da"
import script from "./AddMarginModal.vue?vue&type=script&lang=js"
export * from "./AddMarginModal.vue?vue&type=script&lang=js"
script.render = render

export default script